module.exports = __webpack_public_path__ + "static/lato-light-1b8f8afa9b4ba60fbcf9936eae918ec6.eot";